module.exports = __webpack_public_path__ + "img/15-sjtuiuc.6fb64abf.png";